import cx from 'classnames';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MenuIcon(_ref) {
  let {
    isOrange,
    noOfBars = 3,
    isOpen,
    text
  } = _ref;
  return /*#__PURE__*/_jsxs("span", {
    className: cx('wa-icons-bars', {
      'wa-icons-bars--is-open': isOpen
    }),
    children: [/*#__PURE__*/_jsx("span", {
      className: "wa-icons-bars__container",
      children: [...Array(noOfBars).keys()].map(key => /*#__PURE__*/_jsx("span", {
        className: cx('wa-icons-bars__bar', {
          'wa-icons-bars__bar--orange': isOrange
        })
      }, key))
    }), text ? /*#__PURE__*/_jsx("span", {
      className: "wa-icons-bars__text",
      children: text
    }) : null]
  });
}